import React from 'react';
import c from 'classnames';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import { APP_OPTIONS, SEARCHKIT_HOST_URL } from '../../config/constants';
import {
  facetAttributes,
  highlightAttributes,
  resultAttributes,
  searchAttributes,
  sorting,
} from './config';

// Subcomponents.
// TODO: Implement ActiveFacets
// import ActiveFacets from './ActiveFacets';
import Facets from './Facets';
import Results from './Results';
import SearchBar from './SearchBar';
import SortBy from './SortBy';
import Stats from './Stats';
import Pagination from './Pagination';

interface SearchAllContentSubcomponents {
  // ActiveFacets: typeof ActiveFacets;
  Facets: typeof Facets;
  Results: typeof Results;
  SearchBar: typeof SearchBar;
  SortBy: typeof SortBy;
  Stats: typeof Stats;
  Pagination: typeof Pagination;
}

export type SearchAllContentProps = Omit<SearchkitWrapperProps, 'connection' | 'indexName' | 'analytics' | 'searchSettings'>;

const SearchAllContent: React.FC<SearchAllContentProps> & SearchAllContentSubcomponents = (props) => {
  const {
    routing,
    className,
    children,
    ...restProps
  } = props;

  const classNames = c('SearchAllContent', className);

  return (
    <SearchkitWrapper
      {...restProps}
      className={classNames}
      connection={{ host: SEARCHKIT_HOST_URL }}
      indexName={APP_OPTIONS.parameters.searchkitIndexAllContent}
      routing={routing}
      analytics
      searchSettings={{
        search_attributes: searchAttributes,
        result_attributes: resultAttributes,
        highlight_attributes: highlightAttributes,
        facet_attributes: facetAttributes,
        sorting,
      }}
    >
      {children}
    </SearchkitWrapper>
  );
};

// SearchAllContent.ActiveFacets = ActiveFacets;
SearchAllContent.Facets = Facets;
SearchAllContent.Results = Results;
SearchAllContent.SearchBar = SearchBar;
SearchAllContent.SortBy = SortBy;
SearchAllContent.Stats = Stats;
SearchAllContent.Pagination = Pagination;

export default SearchAllContent;
